import React, { Fragment } from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from "./Link";
import { Typography, WithTheme } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    activeLink: {
      color: "red"
    },
    link: {
      marginRight: theme.spacing(1)
    },
    spacer: {
      display: "inline-block",
      marginRight: theme.spacing(1)
    }
  });

export type BreadcrumbLink = {
  active?: boolean;
  label: string;
  onClick?: () => void;
  route?: string | null;
};

type Props = WithTheme & {
  classes?: any;
  className?: string;
  links: BreadcrumbLink[];
};

const Breadcrumb = ({ classes, className, links, theme }: Props) => (
  <div className={className}>
    {links.map((link: BreadcrumbLink, index: number) => (
      <Fragment key={link.label}>
        <Link
          id={link.label}
          className={classes.link}
          color={
            link.active
              ? theme.palette.primary.dark
              : theme.palette.primary.main
          }
          label={link.label}
          onClick={link.onClick}
          url={link.route}
        />
        {index !== links.length - 1 && (
          <Typography className={classes.spacer} component="span">
            >
          </Typography>
        )}
      </Fragment>
    ))}
  </div>
);

const styled = withStyles(styles, { withTheme: true })(Breadcrumb);
export { styled as Breadcrumb };
